import { HistoryDirection } from 'services/pangolin/types';
import { NetworkHistoryDirection } from 'services/pangolin/protos/network_pb';
import { HostHistoryDirection } from 'services/pangolin/protos/hosts_pb';
import Messages from './directions_messages';

export enum Direction {
  OUTBOUND = 'outbound',
  INBOUND = 'inbound',
  LOCAL = 'local',
}

export const directionsSymbolsMap = new Map<Direction, string>([
  [Direction.OUTBOUND, '\u279A'],
  [Direction.INBOUND, '\u2798'],
  [Direction.LOCAL, '\u2799'],
]);

export const fromHistoryDirectionMap = new Map<HistoryDirection, Direction>([
  [NetworkHistoryDirection.N_H_DIRECTION_EGRESS, Direction.OUTBOUND],
  [NetworkHistoryDirection.N_H_DIRECTION_INGRESS, Direction.INBOUND],
  [NetworkHistoryDirection.N_H_DIRECTION_INTERNAL, Direction.LOCAL],
  [HostHistoryDirection.H_H_DIRECTION_EGRESS, Direction.OUTBOUND],
  [HostHistoryDirection.H_H_DIRECTION_INGRESS, Direction.INBOUND],
  [HostHistoryDirection.H_H_DIRECTION_INTERNAL, Direction.LOCAL],
]);

export function fromHistoryDirection(direction: HistoryDirection) {
  return fromHistoryDirectionMap.get(direction) ?? null;
}

export const ORDERED_DIRECTIONS: readonly Direction[] = [
  Direction.OUTBOUND,
  Direction.INBOUND,
  Direction.LOCAL,
];

export function getFullDirection(direction: Direction|null) {
  return `${getMicroDirection(direction)} ${getShortDirection(direction)}`;
}

export function getShortDirection(direction: Direction|null) {
  switch(direction) {
    case Direction.OUTBOUND:
      return Messages.outbound();
    case Direction.INBOUND:
      return Messages.inbound();
    case Direction.LOCAL:
      return Messages.local();
    default:
      return Messages.unknown();
  }
}

export function getMicroDirection(direction: Direction|null) {
  return (direction !== null ? directionsSymbolsMap.get(direction) : null) ?? '?';
}
